import * as types from "../types/types";

export const toggleSidebar = (isToggle) => ({
  payload: isToggle,
  type: types.TOGGLE_SIDEBAR,
});
